<template>
  <form @submit.prevent="submit">
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-title">
          <p class="has-text-weight-bold title is-4">{{ mode | title }}</p>
          <p class="subtitle is-6" v-if="subtitle">{{ subtitle | ucwords }}</p>
        </div>
      </header>
      <section class="modal-card-body">
        <b-field v-if="requireBasisTagId" label="Reason">
          <b-select v-model="basis_tag_id" placeholder="Select Reason" expanded>
            <option v-for="tag in appealReasons" :key="tag.id" :value="tag.id">
              {{ tag.displayName || tag.name }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Message">
          <b-input v-model="message" type="textarea"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Cancel
        </button>
        <button
          :class="`button is-info ${loading ? 'is-loading' : ''}`"
          :disabled="loading || !canSubmit"
        >
          Submit
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
import { TagService } from "@/services/tag.service";
import { OrderService } from "@/services/order.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  props: {
    orderId: {
      type: String,
      required: true
    },
    startOrFinish: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    }
  },
  filters: {
    title(mode) {
      return mode === "reject" ? "Reject KPI Appeal" : "Send KPI Appeal";
    }
  },
  data: () => ({
    orderService: OrderService,
    message: "",
    basis_tag_id: null, // from pre-defined list
    loading: false,
    reason_tags: []
  }),
  computed: {
    requireBasisTagId() {
      return (
        ["APPEAL", "REVERSE"].indexOf(this.mode.toUpperCase()) > -1 ||
        this.appealReasons.length > 0
      );
    },
    appealReasons() {
      let reasons = [];
      let mode = this.mode.toUpperCase();
      if (["APPEAL", "REVERSE"].indexOf(mode) > -1) {
        const type =
          mode == "APPEAL"
            ? "ORDER_APPEAL_BASIS_PASS"
            : "ORDER_APPEAL_BASIS_FAIL";
        reasons = this.reason_tags.filter(tag => {
          return tag.type.toUpperCase() == type;
        });
      }
      return reasons;
    },
    canSubmit() {
      return (!this.requireBasisTagId || this.basis_tag_id) &&
        this.message.length >= 1
        ? true
        : false;
    }
  },
  mounted() {
    this.loading = true;
    Promise.all([this.getReasonTags()])
      .then(data => {
        this.reason_tags = data[0];
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    getReasonTags() {
      return new Promise((resolve, reject) => {
        TagService.all({
          type: ["ORDER_APPEAL_BASIS_FAIL", "ORDER_APPEAL_BASIS_PASS"]
        })
          .then(data => {
            const tags = JsonDenormalizer.denormalize(data);
            return resolve(tags);
          })
          .catch(err => reject(err));
      });
    },
    async submit() {
      this.loading = true;

      try {
        const order = await this.orderService[`${this.mode}KpiResult`](
          this.orderId,
          {
            comment: this.message,
            basis_tag_id: this.basis_tag_id,
            startOrFinish: this.startOrFinish,
            includes: "kpiLogs"
          }
        ).then(response => JsonDenormalizer.denormalize(response.data));

        let message =
          this.mode === "reject"
            ? "KPI has been rejected."
            : "KPI appeal has been sent.";

        this.$buefy.toast.open({
          message,
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("submit", order);
        this.$store.dispatch("OrderState/fetchState", order.id);
      } catch (err) {}

      this.$parent.close();
      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderKpi/OrderKpiAppealModal.vue